// Web-safe mock for react-native-splash-screen
// Splash screen is not applicable on web, so provide no-op methods

const SplashScreen = {
  show: () => {
    // No-op on web
  },
  hide: () => {
    // No-op on web - splash screen doesn't exist
  },
};

export default SplashScreen;
